import { createContext } from 'react';

const CieloTDCContext = createContext();

export default CieloTDCContext;
